// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__+5V-h","button":"styles_button__vKRuP","heading":"styles_heading__W15w+"};